import req from './request'

const DEFAULT_ENDPOINTS = {
    status: '/comeback',
    drivers: '/comeback/drivers',
    analytics: '/comeback/analytics',
    inWork: '/comeback/in-work',
    history: '/comeback/history',
    calls: '/comeback/calls',
    reference: '/comeback/reference',
    getId: '/comeback/get-id',
    setPromo: '/comeback/set-promo',
    statisticTabs: '/comeback-statistic/tabs',
    statisticChartTotalConversion: '/comeback-statistic/chart-total-conversion',
    statisticChartOperatorConversion: '/comeback-statistic/chart-operator-conversion',
    statisticChartCalls: '/comeback-statistic/chart-calls',
    statisticReference: '/comeback-statistic/reference',
}

export default {
    drivers(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.drivers, param)
    },
    analytics(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.analytics, param)
    },
    inWork(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.inWork, param)
    },
    history(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.history, param)
    },
    calls(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.calls, param)
    },
    status(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.status, param)
    },
    reference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reference, param)
    },
    getId(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.getId, param)
    },
    setPromo(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.setPromo, param)
    },
    statisticTabs(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.statisticTabs, param)
    },
    statisticChartTotalConversion(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.statisticChartTotalConversion, param)
    },
    statisticChartOperatorConversion(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.statisticChartOperatorConversion, param)
    },
    statisticChartCalls(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.statisticChartCalls, param)
    },
    statisticReference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.statisticReference, param)
    }
}
